(() => {
  const STORAGE_KEY = 'loveurcurls-collection-facets-sidebar-open';
  const desktopGridClassPattern = /^grid--[1-6]-col-desktop$/;

  function setGridDesktopColumns(grid, cols) {
    if (!grid) return;
    [...grid.classList].filter((c) => desktopGridClassPattern.test(c)).forEach((c) => grid.classList.remove(c));
    grid.classList.add(`grid--${cols}-col-desktop`);
  }

  function updateToggleLabels(open) {
    // document.querySelectorAll('.facets-sidebar-toggle__show').forEach((el) => el.classList.toggle('hidden', open));
    // document.querySelectorAll('.facets-sidebar-toggle__hide').forEach((el) => el.classList.toggle('hidden', !open));
    document.querySelectorAll('.facets-sidebar-toggle--toolbar').forEach((btn) => {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function syncSidebarState(layout, open) {
    const grid = document.getElementById('product-grid');
    if (!grid || !grid.classList.contains('product-grid') || !layout.dataset.gridDesktop) return;

    const colsFull = layout.dataset.gridDesktop;
    const colsSidebar = layout.dataset.gridWithSidebar || String(Math.max(2, Number(colsFull) - 1));

    layout.classList.toggle('facets-sidebar--collapsed', !open);
    layout.classList.toggle('facets-sidebar--expanded', open);
    updateToggleLabels(open);

    // Match grid columns to sidebar state immediately (do not wait for sidebar width transition).
    setGridDesktopColumns(grid, open ? colsSidebar : colsFull);
  }

  function readStoredOpen() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  }

  function writeStoredOpen(open) {
    try {
      sessionStorage.setItem(STORAGE_KEY, open ? 'true' : 'false');
    } catch {
      /* ignore */
    }
  }

  function bindDelegatedClick() {
    if (window.__collectionFacetsSidebarClickBound) return;
    window.__collectionFacetsSidebarClickBound = true;

    document.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-facets-sidebar-toggle]');
      if (!btn || !document.body.contains(btn)) return;

      const layout = document.querySelector('[data-facets-sidebar-layout]');
      if (!layout) return;

      const shouldOpen = layout.classList.contains('facets-sidebar--collapsed');
      syncSidebarState(layout, shouldOpen);
      writeStoredOpen(shouldOpen);
    });
  }

  function onProductGridUpdated() {
    const layout = document.querySelector('[data-facets-sidebar-layout]');
    if (!layout) return;
    const open = layout.classList.contains('facets-sidebar--expanded');
    syncSidebarState(layout, open);
  }

  function init() {
    const layout = document.querySelector('[data-facets-sidebar-layout]');
    if (!layout) return;

    bindDelegatedClick();

    if (!window.__collectionFacetsSidebarGridListener) {
      window.__collectionFacetsSidebarGridListener = true;
      document.addEventListener('facetFilters:productGridUpdated', onProductGridUpdated);
    }

    syncSidebarState(layout, readStoredOpen());
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
